module.exports = __webpack_public_path__ + "img/oper_fabao.80890bdc.png";